import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

interface AuthState {
    me: null | {
        data: {
            created_at: string;
            email: string;
            email_verified_at: string;
            id: number;
            image: null | string;
            name: string;
            phone: string;
            role: string;
            roles: string[];
            status: number;
            token: string;
            updated_at: string;
            company_logo: null | string;
        };
    };
    token: null | string;
}

const initialState: AuthState = {
    me: null,
    token: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ me: any; token: string | null }>) => {
            state.me = action.payload.me;
            state.token = action.payload.token;

            if (action.payload.token) {
                Cookies.set('accessToken', action.payload.token);
            } else {
                Cookies.remove('accessToken');
            }
        },
        logout: (state) => {
            state.me = null;
            state.token = null;
            Cookies.remove('accessToken');
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
